import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap"
import { COLORS, FONTS } from '../../constants'

export const ResetPassword = (props) => {
  const open = get(props, 'open')
  const toggle = get(props, 'toggle')
  const handleEmail = get(props, 'handleEmail')
  const forgetPassword = get(props, 'forgetPassword')

  return (
    <Modal isOpen={ open } toggle={ toggle }>
      <ModalHeader toggle={ toggle }>
        <Header>Reset Password</Header>
      </ModalHeader>
      <CustomBody>
        <FormGroup>
          Email
          <CustomInput
            type="email"
            name="email"
            placeholder="example@gmail.com"
            onChange={ handleEmail }
          />
        </FormGroup>
      </CustomBody>
      <ModalFooter>
        <CustomButton
          bg_color={ COLORS.SECONDARY_RED }
          bg_hover={ COLORS.SECONDARY_RED_HOVER }
          border={ COLORS.PRIMARY_RED_BORDER }
          font_color={ COLORS.WHITE }
          onClick={ forgetPassword }
        >Send</CustomButton>&nbsp;
        <CustomButton
          bg_color={ COLORS.WHITE }
          bg_hover={ COLORS.GREY }
          border={ COLORS.GREY }
          font_color={ COLORS.BLACK }
          onClick={ toggle }
        >Cancel</CustomButton>
      </ModalFooter>
    </Modal>
  )
}

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const CustomBody = styled(ModalBody)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const CustomInput = styled(Input)`
  font-family: ${FONTS.GOTHAM};
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  background-color: ${props => props.bg_color};
  border: 1px solid ${props => props.border};
  color: ${props => props.font_color};
  :hover {
    background-color: ${props => props.bg_hover};
    color: ${props => props.font_color};
  }
`



// WEBPACK FOOTER //
// ./src/components/login/reset-password.js